export default "__VITE_ASSET___W8_8Kna__"